module.exports = __webpack_public_path__ + "img/layout-alt-04.9b61027d.svg";